import React from 'react';
import {defaultTemplate} from 'core/hoc';
import {renderIf, isSome} from 'core/utils';
import _ from 'lodash';

const BasicFileInputTemplate = defaultTemplate(({ field, t, showLabel = true, accept }) => {
    const { 
        //placeholder,
         ...otherProps } = field.bind();   
    if(otherProps.value && typeof otherProps.value === 'string')
        otherProps.value = otherProps.value.replace(/\s+/g, ' ');
    if(otherProps.value == null)
        otherProps.value = '';

    const requiredMark = field.rules && field.rules.indexOf('required') !== -1 ? <span className="validation__mark">*</span> : null;

    return (
        <div>
            { showLabel && ( <label className="form__group__label" htmlFor={field.id}>{t(field.label)}{requiredMark}</label>) }
            <input value={field && field.files && _.first(field.files) ? _.first(field.files).name : ''} id="uploadFile" placeholder="Choose File" disabled="disabled" />
            <div className="fileUpload btn btn-primary">
                <span>Upload</span>
                <input {...field.bind()} className="upload" accept={accept}
                />
            </div>
            {renderIf(isSome(field.error))(
                <p className="validation__message">{field.error}</p>
            )}
        </div>
    )
});

export default BasicFileInputTemplate;
